/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon20Light = forwardRef('ArrowADownIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9 16.91V2.5a.5.5 0 0 1 1 0v14.41a1.37 1.37 0 0 0 .472-.308l5.237-5.237a.5.5 0 0 1 .707.707L11.18 17.31a2.375 2.375 0 0 1-3.358 0l-5.237-5.237a.5.5 0 1 1 .707-.707l5.237 5.237c.139.139.3.242.472.309Z" })));
});
